/*
 * Contents list for a legal page.
 *
 * Shopify renders a policy as one blob of HTML, so there is nothing in Liquid
 * to build a contents list from. It is built here instead, from the headings
 * that are actually in the document - which also means it can never drift out
 * of step with the text the way a hand-maintained list would.
 *
 * Progressive enhancement throughout: the list starts hidden and is only
 * revealed once there is something real to put in it, so a policy with no
 * headings, or a reader with no JavaScript, gets no empty box.
 */
(function () {
  'use strict';

  var MIN_HEADINGS = 3;

  function slugify(text, used) {
    var base =
      text
        .toLowerCase()
        .replace(/[‘’“”]/g, '')
        .replace(/[^a-z0-9à-ſ]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60) || 'sectie';

    // Two headings can legitimately read the same; ids cannot.
    var id = base;
    var n = 2;
    while (used[id]) {
      id = base + '-' + n;
      n += 1;
    }
    used[id] = true;
    return id;
  }

  function build(root) {
    /*
     * Two shapes of the same page. A custom legal page renders through the
     * section and marks its own body; a shop policy is rendered by Shopify and
     * only ever has its own class, which the theme cannot change.
     */
    var body = root.querySelector('[data-policy-body], .shopify-policy__body');
    var nav = root.querySelector('[data-policy-toc]');
    if (!body || !nav) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (headings.length < MIN_HEADINGS) return;

    var used = {};
    var list = document.createElement('ul');
    list.className = 'knuska-pol__toc-list';

    var links = headings.map(function (heading) {
      var text = (heading.textContent || '').trim();
      if (!heading.id) heading.id = slugify(text, used);

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.className = 'knuska-pol__toc-link';
      link.href = '#' + heading.id;
      link.textContent = text;
      item.appendChild(link);
      list.appendChild(item);
      return link;
    });

    nav.appendChild(list);
    nav.hidden = false;

    highlight(headings, links);
    wrapTables(body);
  }

  /*
   * Mark the section being read. The bottom rootMargin retires a heading once
   * it has scrolled past the upper part of the window, so the current entry is
   * the last heading crossed rather than whichever happens to be on screen.
   */
  function highlight(headings, links) {
    if (!('IntersectionObserver' in window)) return;

    var seen = new Array(headings.length);

    function paint() {
      var current = 0;
      for (var i = 0; i < seen.length; i += 1) {
        if (seen[i]) current = i;
      }
      links.forEach(function (link, i) {
        if (i === current) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var i = headings.indexOf(entry.target);
          if (i > -1) seen[i] = entry.boundingClientRect.top < 0;
        });
        paint();
      },
      { rootMargin: '0px 0px -80% 0px', threshold: 0 }
    );

    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }

  /*
   * Policies sometimes carry a wide table of delivery times or costs. Give it
   * its own scroll box so it cannot force the whole page sideways.
   */
  function wrapTables(body) {
    body.querySelectorAll('table').forEach(function (table) {
      if (table.parentNode.classList.contains('knuska-pol__scroller')) return;
      var box = document.createElement('div');
      box.className = 'knuska-pol__scroller';
      table.parentNode.insertBefore(box, table);
      box.appendChild(table);
    });
  }

  function init() {
    document.querySelectorAll('[data-policy]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor replaces a section's markup wholesale on every edit.
  document.addEventListener('shopify:section:load', init);
})();
